<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[matDialogData]="data"
	[rect]="rect"
	[hideHeader]="true"
	[headerIcon]="{fontSet: 'fas', fontIcon: 'fa-list'}"
	[headerText]="data.title"
>
	<div dialogContent>
		<div class="bottom">
			<div class="text">
				<mat-icon class="waterSign"> info </mat-icon> {{ data.description }}
				<ul style="text-align: initial">
					@for (item of data.myList; track item) {
						<li>
							{{ item }}
						</li>
					}
				</ul>
			</div>
		</div>
	</div>

	<ng-container actions>
		<sim-button
			(onClick)="close({action: 'ok'})"
			[color]="'accent'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="data.okText.toUpperCase()"
		/>
	</ng-container>
</sim-basic-material-dialog>
